;(function () {
    'use strict'

    var root
    var isNode
    if (typeof module !== 'undefined' && module.exports) {
        isNode = true
        root = global
    } else {
        isNode = false
        root = window
    }

    var _
    if (isNode) {
        _ = require('lodash')
    } else {
        _ = root._
    }

    function resolveThreeRadicalFileUrl(fileUrl, newHostname) {
        var pattern = new RegExp(
            '^(https?:\\/\\/)?' + // protocol
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
                '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
                '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
                '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
                '(\\#[-a-z\\d_]*)?$',
            'i'
        ) // fragment locator

        var validUrl = !!pattern.test(fileUrl)
        if (!validUrl) {
            return fileUrl
        }

        if (fileUrl.startsWith('http') && fileUrl.indexOf(window.location.hostname) == -1) {
            var url = new URL(fileUrl)
            if (newHostname) {
                url.hostname = newHostname
            } else {
                if (window.location.hostname) {
                    url.hostname = window.location.hostname
                }
                
                if (window.location.port) {
                    url.port = window.location.port
                }
                
                if (window.location.protocol) {
                    url.protocol = window.location.protocol
                }
            }
            fileUrl = url.href
        }
        return fileUrl
    }

    function remapFilePaths(fileUrl, newHostname) {
        return resolveThreeRadicalFileUrl(fileUrl, newHostname)
    }

    function resolveThreeRadical(
        threeRadical,
        key,
        isFirstRecursion,
        resolveThreeRadicalSubPackage,
        additionalOptions
    ) {
        additionalOptions = additionalOptions || {}
        var isRemapFilePaths = additionalOptions.isRemapFilePaths

        function resolveAgain(newThreeRadical, newKey) {
            return resolveThreeRadical(
                newThreeRadical,
                newKey,
                false,
                resolveThreeRadicalSubPackage,
                additionalOptions
            )
        }

        function remapIfNeeded(value) {
            if (isRemapFilePaths) {
                return remapFilePaths(value, typeof isRemapFilePaths == "string" ? isRemapFilePaths : undefined)
            }

            return value
        }

        var result = {}
        if (isFirstRecursion) {
            for (var property in threeRadical.properties) {
                result[property] = resolveAgain(threeRadical.properties[property], property)
            }
        } else {
            var propType = threeRadical.type.toLowerCase()
            switch (propType) {
                case 'object': {
                    for (var property in threeRadical.properties) {
                        if (threeRadical.properties.hasOwnProperty(property) && typeof threeRadical.properties[property] === "object") {
                            let condition = threeRadical.properties[property].condition
                            if(!condition || (threeRadical.properties[condition.property].value === condition.value)){
                                result[property] = resolveAgain(threeRadical.properties[property], property)
                            }
                        }
                    }
                    break
                }
                case 'array': {
                    result = []
                    for (var itemIndex in threeRadical.value) {
                        result.push(_.cloneDeep(threeRadical.value[itemIndex]))
                    }
                    if (result) {
                        for (var arrayIndex in result) {
                            for (var property in threeRadical.properties) {
                                var arrayPropType = threeRadical.properties[
                                    property
                                ].type.toLowerCase()
                                switch (arrayPropType) {
                                    case 'object': {
                                        var arrayValue = {}
                                        arrayValue[property] = _.merge(
                                            {},
                                            result[arrayIndex][property]
                                        )
                                        result[arrayIndex][property] = resolveAgain(
                                            _.merge(_.cloneDeep(threeRadical.properties[property]), arrayValue[property]),
                                            property
                                        )
                                        break
                                    }
                                    case 'array': {
                                        break
                                    }
                                    case 'package': {
                                        var arrayValue = {}
                                        arrayValue[property] = _.merge(
                                            {},
                                            result[arrayIndex][property]
                                        )
                                        result[arrayIndex][property] = resolveAgain(
                                            _.merge(arrayValue, threeRadical.properties[property]),
                                            property
                                        )
                                        break
                                    }
                                    default:
                                        break
                                }
                            }
                        }
                    }
                    break
                }
                case 'tuple': {
                    result = threeRadical.elements.map(function (item) {
                        return remapIfNeeded(item.value)
                    })
                    break
                }
                case 'package': {
                    if(!resolveThreeRadicalSubPackage) {
                        console.warn(`No subpackage resolver supplied for key ${key}, returning null`)
                        result = null
                    } else {
                        if(threeRadical[key]){
                            result = resolveThreeRadicalSubPackage(threeRadical[key])
                        } else {
                            result = resolveThreeRadicalSubPackage(threeRadical)
                        }
                    }
                    break
                }
                case 'image':
                case 'video':
                case 'file':   
                case 'sound':
                    result = remapIfNeeded(threeRadical.value)
                    break
                default: {
                    result = threeRadical.value
                    break
                }
            }
        }
        return result
    }

    function getPackageGuid(args) {
        var argParts = args.split('/')
        return argParts[argParts.length - 1].replace('.zip', '')
    }

    function camelCase(input) {
        if (Array.isArray(input)) {
            input = input
                .map(function (x) {
                    return x.trim()
                })
                .filter(function (x) {
                    return x.length
                })
                .join('-')
        } else {
            input = input.trim()
        }

        if (input.length === 0) {
            return ''
        }

        var hasUpperCase = input !== input.toLowerCase()

        if (hasUpperCase) {
            input = preserveCamelCase(input)
        }

        input = input
            .replace(/^[_.\- ]+/, '')
            .toLowerCase()
            .replace(/[_.\- ]+(\w|$)/g, function (m, p1) {
                return p1.toUpperCase()
            })
        return input
    }

    function preserveCamelCase(input) {
        var isLastCharLower = false
        var isLastCharUpper = false
        var isLastLastCharUpper = false

        for (var i = 0; i < input.length; i++) {
            var c = input[i]

            if (isLastCharLower && /[a-zA-Z]/.test(c) && c.toUpperCase() === c) {
                input = input.slice(0, i) + '-' + input.slice(i)
                isLastCharLower = false
                isLastLastCharUpper = isLastCharUpper
                isLastCharUpper = true
                i++
            } else if (
                isLastCharUpper &&
                isLastLastCharUpper &&
                /[a-zA-Z]/.test(c) &&
                c.toLowerCase() === c
            ) {
                input = input.slice(0, i - 1) + '-' + input.slice(i - 1)
                isLastLastCharUpper = isLastCharUpper
                isLastCharUpper = false
                isLastCharLower = true
            } else {
                isLastCharLower = c.toLowerCase() === c
                isLastLastCharUpper = isLastCharUpper
                isLastCharUpper = c.toUpperCase() === c
            }
        }

        return input
    }

    function updateThreeRadical(threeRadical, source, isFirstRecursion) {
        if (isFirstRecursion) {
            for (var property in threeRadical.properties) {
                if (source != undefined && source[property] != undefined) {
                    updateThreeRadical(threeRadical.properties[property], source[property])
                }
            }
        } else {
            var propType = threeRadical.type.toLowerCase()
            switch (propType) {
                case 'object': {
                    for (var property in threeRadical.properties) {
                        if (source != undefined && source[property] != undefined) {
                            updateThreeRadical(threeRadical.properties[property], source[property])
                        }
                    }
                    break
                }
                case 'array': {
                    threeRadical.value = (source || []).map(function (arrayItem) {
                        var itemValue = {}

                        for(var arrayPropKey in threeRadical.properties) {
                            if (threeRadical.properties.hasOwnProperty(arrayPropKey) && threeRadical.properties[arrayPropKey].type) {

                                var arrayProp = threeRadical.properties[arrayPropKey]
                                var arrayPropType = arrayProp.type.toLowerCase()

                                switch (arrayPropType) {
                                    case 'object': {
                                        var objectProp = { properties: JSON.parse(JSON.stringify(arrayProp.properties)) }
                                        var objectPropSource = arrayItem[arrayPropKey]

                                        for (var propKey in objectProp.properties) {
                                            if (objectProp.properties.hasOwnProperty(propKey)) {
                                                updateThreeRadical(objectProp.properties[propKey], objectPropSource[propKey])
                                            }
                                        }

                                        itemValue[arrayPropKey] = objectProp
                                        break
                                    }
                                    default: {
                                        itemValue[arrayPropKey] = arrayItem[arrayPropKey]
                                        break
                                    }
                                }
                            }
                        }

                        return itemValue
                    })
                    break
                }
                case 'tuple': {
                    if (source != undefined && source != null) {
                        for (var element in threeRadical.elements) {
                            threeRadical.elements[element].value = source[element]
                        }
                    }
                    break
                }
                case 'package': {
                    if (typeof source == "object") {
                        for (var sKey in source) {
                            if (source.hasOwnProperty(sKey)) {
                                threeRadical[sKey] = source[sKey]
                            }
                        }
                    }
                    break
                }
                default: {
                    if (source != undefined && source != null) {
                        threeRadical.value = source
                    }
                    break
                }
            }
        }
    }
    
    function getPackageUrl (message) {
    	let externalPackage = (((message.quantities || {}).link || {}).data || {}).externalPackage
    	
    	if (externalPackage.uploadOption && externalPackage.uploadOption == "selectPackage") {
    		return externalPackage.selectedPackageFile
    	}
    	
    	return externalPackage.metadataPath
    }
    
    function getThreeRadical (message) {
    	return ((((message.quantities || {}).link || {}).data || {}).externalPackage || {}).threeRadical
    }
    
    function getData (message) {
    	return (((message.quantities || {}).link || {}).data || {})
    }
    
    function getPackageName (message) {
        let threeRadical = getThreeRadical(message)
        /*
        if (!threeRadical && this.simpleMessageHandler) {
        	return Promise.resolve(this.simpleMessageHandler)
        } else if (!threeRadical) {
        	return Promise.reject(new Error("No Three Radical Data"))
        }
        */
        if (!threeRadical) {
        	return Promise.reject(new Error("No Three Radical Data"))
        }
        
        if (threeRadical._package && threeRadical._package.name) {
            return Promise.resolve(threeRadical._package.name)
        }
        
        let packageUrl = getPackageUrl(message) 
        let selfDevice = this.run('3r/Device')
        return new Promise(function(resolve, reject) {
            selfDevice.gtp("/external-package/" + message.schemeId + "/" + getPackageGuid(packageUrl) + "/package/name").then(function(result){		  
    			resolve(result)
    		}, function(e){
    			reject(e)
    		}).catch(function(e){
    			reject(e)
    		})
        })
    }

/* Here to trick module loaders:
exports.thing = something
*/

    if (isNode) {
        module.exports = {
            resolveThreeRadical: resolveThreeRadical,
            updateThreeRadical: updateThreeRadical,
            resolveThreeRadicalFileUrl: resolveThreeRadicalFileUrl,
            camelCase: camelCase,
            getPackageGuid: getPackageGuid,
            getPackageName: getPackageName,
            getThreeRadical: getThreeRadical,
            getData: getData
        }
    } else {
        root.threeRadicalResolver = _.merge(root.threeRadicalResolver || {}, {
            resolveThreeRadical: resolveThreeRadical,
            updateThreeRadical: updateThreeRadical,
            resolveThreeRadicalFileUrl: resolveThreeRadicalFileUrl,
            camelCase: camelCase,
            getPackageGuid: getPackageGuid,
            getPackageName: getPackageName,
            getThreeRadical: getThreeRadical,
            getData: getData
        })
    }
})()
